import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useUpdateFactoryPOMutation } from '@features/order/api/OrderDetailsApi';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { capitalizeFirstLetter } from '@utils/Util';

const PaymentInfo = ({ factoryId, factoryPODetails }) => {
	const [paymentTerms, setPaymentTerms] = useState('');
	const [updateFactoryPO] = useUpdateFactoryPOMutation();
	const dispatch = useDispatch();

	useEffect(() => {
		setPaymentTerms(factoryPODetails?.paymentTerms);
	}, [factoryPODetails?.paymentTerms]);

	const renderShipViaOptions = () => {
		const data = [
			{ label: 'Air', value: 'Air' },
			{ label: 'Courier', value: 'Courier' },
			{ label: 'Sea', value: 'SEA' }
		];

		const updateShipVia = async (item) => {
			try {
				dispatch(openLoader());
				await updateFactoryPO({
					id: factoryId,
					requestBody: {
						shipVia: item.value
					}
				});
			} finally {
				dispatch(closeLoader());
			}
		};

		return data?.map((item, i) => (
			<li
				role="presentation"
				className={`px-4 pb-3 ${i === 0 ? 'pt-3' : ''}`}
				onClick={() => updateShipVia(item)}
			>
				<a role="menuitem" tabIndex={-1} className="font-weight-normal text-black">
					{item.label}
				</a>
			</li>
		));
	};

	return (
		<div className="payment-and-info-details-table mt-3">
			<div className="title mb-12">
				<h3 className="semibold-18">Payment & other info details</h3>
			</div>
			<table className="table with-border no-hover">
				<thead>
					<tr>
						<th>Sub-brand</th>
						<th>Ship Via</th>
						<th>Incoterm Location</th>
						<th>Payment terms</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td className="sub-brand-column">{factoryPODetails?.subBrandName}</td>
						<td className="ship-via-column">
							<div className="option">
								<div className="dropdown rotatable-arrow">
									<button
										className="btn w-100 text-left btn-default dropdown-toggle gray_dark_02 regular-14"
										type="button"
										id="menu1"
										data-toggle="dropdown"
										aria-expanded="false"
									>
										{capitalizeFirstLetter(factoryPODetails?.shipVia) || 'Select'}
										<img src="/icons/down-arrow.png" className="arrow ml-2" alt="" />
									</button>
									<ul
										className="dropdown-menu drdropdown-menu-right shadow-lg"
										role="menu"
										aria-labelledby="menu1"
										x-placement="bottom-end"
									>
										{renderShipViaOptions()}
									</ul>
								</div>
							</div>
						</td>
						<td className="sub-brand-column">{factoryPODetails?.incotermsLocation}</td>
						<td className="payment-terms-column">
							<input
								type="text"
								value={paymentTerms}
								onChange={(e) => setPaymentTerms(e.target.value)}
								onBlur={(e) => {
									updateFactoryPO({
										id: factoryId,
										requestBody: {
											paymentTerms: e.target.value
										}
									});
								}}
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	);
};

export default PaymentInfo;
